// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const CveIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 14 15">
    <path
      fill="currentColor"
      d="M11.2 9.41h2.1a.7.7 0 0 0 .5-.2.7.7 0 0 0 0-1.02.7.7 0 0 0-.5-.2h-2.1V6.54h2.1a.7.7 0 0 0 .5-.2.7.7 0 0 0 0-1.02.7.7 0 0 0-.5-.2h-2.35A4.3 4.3 0 0 0 9.4 3.07l1.79-1.86a.7.7 0 0 0 .2-.5.7.7 0 0 0-.2-.52.7.7 0 0 0-.98 0L8.05 2.36q-.52-.11-1.05-.1a4 4 0 0 0-1.02.15L3.88.2a.7.7 0 0 0-1.14.23.7.7 0 0 0 .16.78l1.72 1.77q-1.07.79-1.54 2.05H.7a.7.7 0 0 0-.5.2.7.7 0 0 0 0 1.02q.21.2.5.2h2.1V7.9H.7a.7.7 0 0 0-.5.2.7.7 0 0 0 0 1.02q.21.2.5.2h2.1v1.43H.7a.7.7 0 0 0-.5.21.7.7 0 0 0 0 1.01q.21.21.5.21h2.38a4.3 4.3 0 0 0 3.22 2.76V7.6q0-.3.2-.51a.7.7 0 0 1 1 0q.2.21.2.5V15a4.2 4.2 0 0 0 3.25-2.73h2.35a.7.7 0 0 0 .5-.21.7.7 0 0 0 0-1.01.7.7 0 0 0-.5-.21h-2.1z"
    />
  </svg>,
  "Cve",
);
export default CveIcon;
